<template>
  <div id="breadcrumb" v-if="$route.path != '/'">
    <div class="breadcrumb flex align_items_ctr">
      <span>您的位置：</span>
      <span>
        <span
          v-for="(item, index) in pathList"
          :key="index"
          @click="goPageClick(item.path, index)"
          :class="{ breadcrumb_txt: index != pathList.length - 1 }"
        >
          {{ item.title }}
          <span v-if="index != pathList.length - 1">-</span></span
        >
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "breadcrumb",
  data() {
    return {
      pathList: [],
    };
  },
  created() {
    this.setBreadcrumb();
  },
  methods: {
    goPageClick(path, index) {
      if (index < this.pathList.length - 1) {
        this.$router.push(path);
      }
    },
    setBreadcrumb() {
      this.pathList = [];
      let currentRouteObj = this.$route;
      let currentroute = {
        path: currentRouteObj.path,
        title: currentRouteObj.meta.title,
      };
      let indexRoute = { path: "/", title: "首页" };
      let breadList = (currentRouteObj.meta && currentRouteObj.meta.bread) || [];
      this.pathList = [indexRoute, ...breadList, currentroute];
    },
  },
  watch: {
    $route() {
      this.setBreadcrumb();
    },
  },
};
</script>

<style lang="less" scoped>
#breadcrumb {
  // padding-top: 100px;
  margin: 0 auto;
  width: 1600px;
  padding: 0 12px;
  box-sizing: border-box;
  height: 50px;
  color: #858d8f;
  // background-color: #f1f5f6;
  font-size: 13px;

  .breadCrumb_icon {
    display: inline-block;
    margin-right: 8px;
  }

  span {
    line-height: 50px;
  }
}

.breadcrumb_txt {
  &:hover {
    color: #000;
    cursor: pointer;
  }
}

.location_icon {
  // width: 10px;
  // height: 14px;
  margin-right: 9px;
}
</style>